
    import {
      getAllRuleVaccinations,
      createRuleVaccination,
      createAllRuleVaccinations,
      updateRuleVaccination,
      deleteRuleVaccination
    } from "@/services/ruleVaccination";

    const state = {
      ruleVaccinations: [],
      processed: false
    };

    const getters = {
      getRuleVaccinations(state) {
        return state.ruleVaccinations;
      },
      ruleVaccinationProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchRuleVaccinations({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllRuleVaccinations(
              params
            )
              .then(response => {
                commit("SET_RULEVACCINATIONS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createRuleVaccination({ commit }, ruleVaccination) {
          return new Promise((resolve, reject) => {
            createRuleVaccination(ruleVaccination)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllRuleVaccinations({ commit }, ruleVaccinations) {
          return new Promise((resolve, reject) => {
            createAllRuleVaccinations(ruleVaccinations)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateRuleVaccination({ commit }, ruleVaccination) {
          return new Promise((resolve, reject) => {
            updateRuleVaccination(ruleVaccination)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteRuleVaccination({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteRuleVaccination(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_RULEVACCINATIONS(state, data) {
        state.ruleVaccinations = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    